(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.controller 
  (:require [frontend.ui.component.chart.utils :as chart-utils]
            [frontend.ui.component.lp-portal.donut-chart.view :as donut-chart]
            [frontend.ui.component.lp-portal.report.component.map.controller :as map]
            [frontend.ui.component.lp-portal.report.component.multi-chart.controller :as multi-controller]
            [frontend.ui.component.lp-portal.report.controller :as report-ctl]
            [frontend.ui.page.lp-portal.report.util :as util]))


(defn ->ui-data
  [{:keys [report-data] :as props}]
  {:fund-name           (:fund-name report-data)
   :reference-date      (:reference-date report-data)
   :basic-information {:figures (:basic-information report-data)}
   :nav-per-unit-series {:figures (:nav-per-unit-series report-data)}
   :unit-value (report-ctl/with-footnote
                 props
                 :unit-value-footnotes
                 (multi-controller/multi-chart-ctl
                  (:unit-value report-data)
                  report-data))
   :total-return-by-unit-series {:figures (:total-return-by-unit-series report-data)}
   :portfolio-allocation {:figures (donut-chart/donut-chart-config (util/->array-of-tuples (:portfolio-allocation report-data) :amount-pct)
                                                                   {:data-label-formatter
                                                                    chart-utils/pie-%-label-formatter-no-division})}
   :portfolio-by-country-fair-value {:figures
                                     (donut-chart/donut-chart-config (util/->array-of-tuples (:portfolio-by-country-fair-value report-data) :fair-value-pct)
                                                                     {:data-label-formatter
                                                                      chart-utils/pie-%-label-formatter-no-division})}
   :investments-map {:figures (map/map-controller (merge (:investments-map report-data) {:highlight-only? true}) map/highcharts-europe-topo)}
   :fund-update-1 (report-ctl/rich-content
                   props
                   :fund-update-1)
   :fund-update-2 (report-ctl/rich-content
                   props
                   :fund-update-2)
   :sustainability-text-1 (report-ctl/rich-content
                           props
                           :sustainability-text-1)
   :sustainability-text-2 (report-ctl/rich-content
                           props
                           :sustainability-text-2)
   :sustainability-text-3 (report-ctl/rich-content
                           props
                           :sustainability-text-3)})
